import { useEffect, useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Home } from "lucide-react";
import { api } from "../lib/api";
import { useSEO } from "../lib/seo";

// Alleen in Beheer goedgekeurde doorverwijzingen (bijv. een gewijzigd webadres van een plaatspagina).
const useApprovedRedirect = (pathname) => {
  const [target, setTarget] = useState(undefined);
  useEffect(() => {
    let on = true;
    setTarget(undefined);
    api.get("/redirects/resolve", { params: { path: pathname } })
      .then((r) => on && setTarget(r.data?.to_path || null)).catch(() => on && setTarget(null));
    return () => { on = false; };
  }, [pathname]);
  return target;
};

export default function NotFound() {
  const { pathname } = useLocation();
  const target = useApprovedRedirect(pathname);
  useSEO({
    title: "Pagina niet gevonden | Maas Kozijn",
    description: "Deze pagina bestaat niet of is verplaatst.",
    noindex: true,
  });
  if (target && target !== pathname) return <Navigate to={target} replace />;
  if (target === undefined) return <div className="min-h-[60vh]" data-testid="not-found-checking" />;
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-20" data-testid="not-found-page">
      <div className="text-center max-w-lg">
        <span className="text-7xl font-display font-semibold text-gold">404</span>
        <h1 className="mt-4 text-3xl font-display font-semibold text-petrol">Pagina niet gevonden</h1>
        <p className="mt-3 text-slate-600">De pagina die u zoekt bestaat niet of is verplaatst. Ga terug naar de homepage of bekijk ons werkgebied.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-gold" data-testid="not-found-home"><Home className="h-4 w-4" /> Naar homepage</Link>
          <Link to="/contact" className="btn-outline-petrol" data-testid="not-found-contact">Contact opnemen</Link>
        </div>
      </div>
    </div>
  );
}
